import { connect } from 'react-redux';
import { getCurrentModal } from '../../../Modals/redux/selectors';
import { ModalType } from '../../../Modals/redux/types';
import { likeComment, unlikeComment } from '../../actionCreators';
import { getCurrentUser, getIsLoggedIn } from '../../../publicSession';
import { restrictLoggedOut } from '../../../redux/loggedout';
import { focusEditor } from '../../../CommentBox/actionCreators';
var mapStateToProps = function (state) {
    var currentModal = getCurrentModal(state);
    return {
        // TODO: this doesn't necessarily mean _this_ comment is in the comment modal
        // there should be a better way to determine this
        isModal: currentModal && currentModal.type === ModalType.COMMENT_THREAD,
        currentUser: getCurrentUser(state),
        isLoggedIn: getIsLoggedIn(state),
    };
};
var mapDispatchToProps = {
    onLike: likeComment,
    onUnlike: unlikeComment,
    focusEditor: focusEditor,
    restrictLoggedOut: restrictLoggedOut,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=CommentFooter.container.js.map